import { Logo } from "@/components/ui/logo";

export function FullScreenLoader({ label = "Cargando…" }: { label?: string }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#f5f6fa] text-[#1f2433] dark:bg-[#101315] dark:text-white" role="status">
      <Logo markClassName="h-12 w-12 animate-pulse" textClassName="dark:text-white" />
      <p className="text-sm text-[#8190b0]">{label}</p>
    </div>
  );
}
